var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('i',{class:_vm.name,style:({ fontSize: _vm.sizeMap[_vm.size] || _vm.size })})}
var staticRenderFns = []

export { render, staticRenderFns }